import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const ValidatePhotoApi = {
  validatePhoto: async (userId, file) => {
    console.log("[API] Preparing formData for validation...");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", userId);

    console.log("[API] 🍱 FormData contents:", [...formData.entries()]);
    console.log("[API] 📡 POST →", Configs.validatePhotoEp);

    try {
      // axiosInstance refreshes an expired access token and retries; the
      // longer timeout covers Sightengine plus a possible Gemini fallback.
      const response = await axiosInstance.post(Configs.validatePhotoEp, formData, {
        // Overrides axiosInstance's JSON default: with a JSON content type,
        // axios serializes FormData to JSON and the file is dropped.
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 60000,
      });

      console.log("[API] ✅ Validation Response:", response.data);
      return response.data;
    } catch (error) {
      console.log("[API] ❌ Validation Error:", error.response?.data || error);
      const body = error.response?.data;
      if (body?.status && body?.data) {
        return body;
      }
      return {
        status: "fail",
        data: {
          message:
            "We couldn't check your photo right now. Please try again.",
        },
      };
    }
  },
};

export default ValidatePhotoApi;
